<template>
  <b-modal
      class=""
      id="CSKH-national-list-modal"
      tabindex="-1"
      size="xl"
      hide-footer
  >
    <div class="modal-dialog modal-xl custom-modal" role="document">
      <div class="row g-3 ">
        <div v-for="(item, index) in nationalList"
             :key="index"
             class="col-4 g-3 mb-2">
          <div class="d-flex align-items-center p-3 bg-light rounded-3 h-100 shadow-sm hover-card">
      <span class="badge bg-primary rounded-circle d-flex align-items-center justify-content-center mr-2"
            style="width: 36px; height: 36px; font-size: 14px;">
        {{ index + 1 }}
      </span>
            <span class="ms-3 text-secondary fw-medium">{{ item }}</span>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>

export default {
  name: "NationalListModal",
  computed: {},
  methods: {
    Close() {
      this.$bvModal.hide("CSKH-national-list-modal")
    },
  },
  data() {
    return {
      nationalList: [
        "Liên bang Nga (Russian Federation)",
        "Nhật Bản (Japan)",
        "Hàn Quốc (Korea/South Korea)",
        "Na Uy (Norway)",
        "Phần Lan (Finland)",
        "Đan Mạch (Denmark)",
        "Thuỵ Điển (Sweden)",
        "Anh (United Kingdom)",
        "Pháp (France)",
        "Đức (Germany)",
        "Tây Ban Nha (Spain)",
        "I-ta-li-a (Italy)",
        "Bê-la-rút (Belarus)",
        "Quan chức Ban thư ký ASEAN"
      ]
    }
  },
}
</script>
